/**
 * @license EUPL-1.2
 * Copyright (c) 2020-2024 Frameless B.V.
 * Copyright (c) 2021-2024 Gemeente Utrecht
 */

@import "~@utrecht/icon-css/src/mixin";

:host {
  @include utrecht-icon;
}

svg {
  @include utrecht-icon__svg;
}
